module.exports = __webpack_public_path__ + "static/Authorized Distributor-219ef22a590c0562bf879f3dac126671.jpg";